import uniq from 'lodash/uniq';
import { ReactNode } from 'react';
import { CSSObjectWithLabel, GroupBase, StylesConfig } from 'react-select';

import { DefaultTheme } from 'ui/selectv2/Themes';
import { BaseOption } from 'ui/selectv2/types';
import { TagGroupValue, VisibleTagGroupOption } from '../types';

export const tagToVisibleTagOption = (tag: TagGroupValue): VisibleTagGroupOption => {
  if (typeof tag === 'string') return { text: tag };

  return tag;
};

/**
 * Helper function to get text from any tag format
 */
export const getTagText = (tag: TagGroupValue): string => {
  if (typeof tag === 'string') return tag;

  return tag?.text || '';
};

/**
 * Generates select options from a list of tags
 */
export const generateTagOptions = (tags: TagGroupValue[]): BaseOption<string>[] =>
  tags.map((tag: TagGroupValue) => {
    const text = getTagText(tag);
    return { id: text, value: text, label: text };
  });

/**
 * Helper function to remove specific tag from list
 */
export const removeTagFromList = (targetTag: string, tagList: string[]) =>
  uniq([...tagList, targetTag]);

/**
 * Filters tags based on the filter text
 */
export const getFilteredTags = (filter: string, tags: string[]) => {
  const filterText = typeof filter === 'string' ? filter.toLowerCase() : '';

  return tags.filter((tag) => {
    if (typeof tag !== 'string') return;

    return tag.toLowerCase().startsWith(filterText);
  });
};

export const tagGroupSelectCustomTheme = (
  errorMsg?: ReactNode,
): StylesConfig<BaseOption<string>, boolean, GroupBase<BaseOption<string>>> => {
  const defaultTheme = DefaultTheme(errorMsg);
  return {
    ...defaultTheme,
    input: (baseStyles: CSSObjectWithLabel): CSSObjectWithLabel =>
      ({
        ...baseStyles,
        ...defaultTheme.input(baseStyles),
        maxWidth: 150,
        '& input': {
          width: 'fit-content!important',
          maxWidth: 150,
        },
      }) as CSSObjectWithLabel,
  } as StylesConfig<BaseOption<string>, boolean, GroupBase<BaseOption<string>>>;
};
